import { render, staticRenderFns } from "./SeminarOrderList.vue?vue&type=template&id=cc0a3456&"
import script from "./SeminarOrderList.vue?vue&type=script&lang=js&"
export * from "./SeminarOrderList.vue?vue&type=script&lang=js&"
import style0 from "./SeminarOrderList.vue?vue&type=style&index=0&id=cc0a3456&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports